const absToUrlPath = abs => abs.split("/").filter(Boolean).join(":");

const urlPathToAbs = urlPath => "/" + urlPath.split(":").join("/");

// a folder url is built from the folder's place in the tree, so renaming or
// moving the folder you are standing in leaves the url pointing at a place
// that no longer exists. this rebuilds that url, descendants included, and
// returns null when the current url is not affected by the change
export const buildSyncedFolderUrl = ({
  pathname,
  search = "",
  basePath = "/mailboxes",
  oldAbsPath,
  newAbsPath
}) => {
  if (!oldAbsPath || !newAbsPath || oldAbsPath === newAbsPath) return null;

  const mailboxMatch = pathname.match(new RegExp(`^${basePath}/([^/]+)(.*)$`));
  if (!mailboxMatch) return null;

  const currentUrlPath = mailboxMatch[1];
  const restPath = mailboxMatch[2] || "";

  const currentAbsPath = urlPathToAbs(currentUrlPath);

  const isAffected =
    currentAbsPath === oldAbsPath ||
    currentAbsPath.startsWith(oldAbsPath + "/");

  if (!isAffected) return null;

  const childSuffix = currentAbsPath.slice(oldAbsPath.length);

  const newUrlPath = absToUrlPath(newAbsPath + childSuffix);

  let newSearch = search;

  if (search.includes("folder=")) {
    const params = new URLSearchParams(search);
    const folderParam = params.get("folder");

    if (folderParam) {
      const decoded = decodeURIComponent(folderParam);
      const decodedAbs = urlPathToAbs(decoded);

      if (
        decodedAbs === oldAbsPath ||
        decodedAbs.startsWith(oldAbsPath + "/")
      ) {
        const updatedAbs = newAbsPath + decodedAbs.slice(oldAbsPath.length);

        params.set("folder", encodeURIComponent(absToUrlPath(updatedAbs)));
        newSearch = `?${params.toString()}`;
      }
    }
  }

  return `${basePath}/${newUrlPath}${restPath}${newSearch}`;
};

export const syncUrlAfterRename = ({
  location,
  navigate,
  renamedFolderOldAbsPath,
  renamedFolderNewAbsPath
}) => {
  const url = buildSyncedFolderUrl({
    pathname: location.pathname,
    search: location.search,
    oldAbsPath: renamedFolderOldAbsPath,
    newAbsPath: renamedFolderNewAbsPath
  });

  if (!url) return;

  navigate(url, { replace: true });
};
